import { Icon } from '@eventbrite/eds-icon';
import { MegaphoneChunky } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import { css, cx } from 'emotion';
import React from 'react';
import { Fire } from './Fire';
import { useUrgencyMessages } from './provider';
import { UrgencyMessageType } from './types';

export const UrgencyMessages: React.FC = () => {
    const values = useUrgencyMessages();

    return (
        <>
            {values[UrgencyMessageType.FewTickets] && (
                <div
                    className={cx(
                        styles.base,
                        styles[UrgencyMessageType.FewTickets],
                    )}
                >
                    <Icon type={<Fire />} size="xsmall" />
                    {gettext('Few tickets left')}
                </div>
            )}
            {values[UrgencyMessageType.SalesEndSoon] && (
                <div
                    className={cx(
                        styles.base,
                        styles[UrgencyMessageType.SalesEndSoon],
                    )}
                >
                    <Icon
                        type={<MegaphoneChunky />}
                        size="small"
                        color="boost-purple"
                    />
                    {gettext('Ticket sales end soon')}
                </div>
            )}
        </>
    );
};

const styles = {
    base: css`
        align-items: center;
        border-radius: 16px;
        column-gap: 6px;
        display: inline-flex;
        font-weight: 600;
        line-height: 1;
        margin: 4px;
        padding: 4px 12px;
    `,
    [UrgencyMessageType.FewTickets]: css`
        background-color: #f8e8eb;
        color: #c5162e;
    `,
    [UrgencyMessageType.SalesEndSoon]: css`
        background-color: #eeeafb;
        color: #5328d7;
    `,
};
